// Search and emulation functionality

function doSearch(inputId, fieldClassName) {
  const filter = $(inputId).val().toUpperCase()
  $('.user').hide()
  
  $(fieldClassName).each(function() {
    const text = this.innerText.toUpperCase()
    if (text.indexOf(filter) > -1) {
      this.parentElement.parentElement.style.display = ''
    }
  })
}

// Make doSearch available globally for inline handlers
window.doSearch = doSearch

document.addEventListener('turbo:load', () => {
  // Search emulation list by company_id
  $('#company_id').on('keyup', function(e) {
    if (e.keyCode === 13) {
      doSearch('#company_id', '.company_id')
    } else {
      doSearch('#company_id', '.company_id')
    }
  })

  // Search emulation list by user's name
  $('#emulate-search').on('click', () => {
    doSearch('#emulation-search', '.username')
  })

  $('#emulation-search').on('keyup', function(e) {
    if (e.keyCode === 13) {
      doSearch('#emulation-search', '.username')
    }
  })

  // Show all users
  $('#show-all').on('click', () => {
    $('#emulation-search').val('')
    $('#company_id').val('')
    doSearch('#company_id', '.company_id')
  })
})

export { doSearch }
